import type { AxiosRequestConfig } from 'axios';

import router from '@/router';
import { useAbortControllerStore } from '@/stores/AbortController';

export default async (
  config: AxiosRequestConfig,
): Promise<AxiosRequestConfig> => {
  if (config.params?.allowNavigations === true) {
    delete config.params.allowNavigations;
    return config;
  }

  const { addAbortController } = useAbortControllerStore();

  const controller: AbortController =
    config.params?.abortController ?? new AbortController();
  config.signal = controller.signal;
  addAbortController(controller, router.currentRoute.value);

  return config;
};
